import React from 'react';
import ReactGA from 'react-ga';

import PageContent from '../../components/Layout/PageContent';
import { TableGridApiContextProvider } from '../../components/TableGrid/TableGridApiContext/TableGridApiContext';
import { CONSTANTS } from '../../core/config/constants';
import { FilterContextProvider } from '../FinancialData/shared/FinancialDataContext/FinancialDataContext';
import { QueryListContextProvider } from './Context/QueryListContext';
import { QueryListAdminBlock } from './QueryListAdminBlock';

interface OwnProps {
  path: string;
}

const QueryListAdminPage: React.FunctionComponent<OwnProps> = () => {
  ReactGA.pageview(window.location.pathname);
  return (
    <PageContent isPageHeightAuto={false}>
      <TableGridApiContextProvider>
        <QueryListContextProvider>
          <FilterContextProvider
            version={CONSTANTS.COMPANIES_FILTER_STORAGE.VERSION}
            storageKey={CONSTANTS.COMPANIES_FILTER_STORAGE.KEY}
          >
            <QueryListAdminBlock />
          </FilterContextProvider>
        </QueryListContextProvider>
      </TableGridApiContextProvider>
    </PageContent>
  );
};

export default QueryListAdminPage;
